"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Refund = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Refund_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.169 1C4.199 1 1 4.146 1 8s3.2 7 7.169 7c2.79 0 5.202-1.556 6.387-3.82a.5.5 0 1 1 .886.463C14.088 14.233 11.336 16 8.17 16 3.668 16 0 12.43 0 8 0 3.572 3.668 0 8.17 0a8.21 8.21 0 0 1 6.676 3.39l.155.197V1.5a.5.5 0 0 1 1 0V5a.5.5 0 0 1-.5.5H12a.5.5 0 0 1 0-1h2.447l-.4-.507-.007-.009A7.21 7.21 0 0 0 8.17 1.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.524 11.75c.362.089.723.14 1.084.157v1.096h.856V11.86c.658-.113 1.16-.378 1.506-.795.353-.426.53-.94.53-1.543 0-.401-.076-.734-.229-1a1.984 1.984 0 0 0-.663-.71 5.247 5.247 0 0 0-1.144-.555V5.437c.24.032.49.084.747.157.257.072.502.176.735.313l.41-1.386a5.273 5.273 0 0 0-.928-.361 4.346 4.346 0 0 0-.964-.18v-.82h-.856v.831c-.417.04-.783.153-1.096.338a2.016 2.016 0 0 0-.747.723c-.177.305-.265.674-.265 1.108 0 .41.08.763.241 1.06.16.29.398.542.71.76.314.208.7.405 1.157.59v1.927a3.549 3.549 0 0 1-1.06-.229 6.096 6.096 0 0 1-1-.494v1.639c.297.137.623.249.976.337Zm2.362-1.638c-.08.128-.221.225-.422.289V8.907c.12.064.22.133.301.205a.58.58 0 0 1 .193.229c.04.088.06.193.06.313 0 .177-.044.33-.132.458ZM7.259 5.594a.935.935 0 0 1 .35-.145v1.47a2.844 2.844 0 0 1-.338-.205.715.715 0 0 1-.193-.229.72.72 0 0 1-.06-.3c0-.137.02-.254.06-.35.04-.097.1-.177.181-.241Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Refund_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Refund;
exports["default"] = _default;